<div class="tip">
    @if (showTipInstructions()) {
        <div class="tip-instructions">
            {{ orderingContextModel.currentStore().tipInstructions || ('woa.message.tip.default' | translate) }}
        </div>
    }
    <div class="tip-options">
        @for (percentage of tipPercentages(); track $index; let i = $index) {
            <div class="tip-options-option" [ngClass]="{'selected': selectedTipIndex() === i}"
                 woa-activatable (onActivate)="selectTip(i)">
                @if (percentage) {
                    <div class="tip-options-option-percentage">
                        {{ percentage }}%
                    </div>
                    <div class="tip-options-option-amount">
                        {{ tipAmounts()[i] | woaCurrency }}
                    </div>
                } @else {
                    <div class="tip-options-option-no-tip">
                        {{ 'woa.label.tip.noTip' | translate }}
                    </div>
                }
            </div>
        }
    </div>
</div>
